import Pagination from '../vc-pagination/locale/mn_MN'
import DatePicker from '../date-picker/locale/mn_MN'
import TimePicker from '../time-picker/locale/mn_MN'
import Calendar from '../calendar/locale/mn_MN'

export default {
  locale: 'mn-mn',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Хайх цэс',
    filterConfirm: 'OK',
    filterReset: 'Цэвэрлэх',
    emptyText: 'Мэдээлэл байхгүй байна',
    selectAll: 'Бүгдийг сонгох',
    selectInvert: 'Бусдыг сонгох',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Цуцлах',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Цуцлах',
  },
  Transfer: {
    notFoundContent: 'Олдсонгүй',
    searchPlaceholder: 'Хайх',
    itemUnit: 'Зүйл',
    itemsUnit: 'Зүйлүүд',
  },
  Select: {
    notFoundContent: 'Олдсонгүй',
  },
  Upload: {
    uploading: 'Хуулж байна...',
    removeFile: 'Файл устгах',
    uploadError: 'Хуулахад алдаа гарлаа',
    previewFile: 'Файлыг түргэн үзэх',
  },
}



// WEBPACK FOOTER //
// ./components/locale-provider/mn_MN.js